'use strict';
const cleanDOMId = require('./clean-dom-id');
module.exports = function connectorKey(connectorObj) {
	return cleanDOMId('connector_' + connectorObj.from + '_' + connectorObj.to);
};

